import styled from 'styled-components';
import PropTypes from 'prop-types';
import CustomPropTypes from '../../util/custom-prop-types';
import { TooltipMixin } from '../../mixins/components/TooltipMixin';
import Popover from '../Popover/Popover';
/**
 * Tooltips differ from [`Popover`](#/Dialog%20components?id=popover) in that they should
 * only be visible on hover or focus.  As such, tooltip content should be brief and non-essential to
 * the task as the content may not be accessible to all users.
 *
 * Tooltips are built on top of the [`Popover`](#/Dialog%20components?id=popover)
 * and [`Dialog`](#/Dialog%20components?id=dialog) components.
 *
 * @since 7.0.0
 */

var Tooltip = /*#__PURE__*/styled(Popover).withConfig({
  displayName: "Tooltip",
  componentId: "c11n-8-64-0__sc-11y2kok-0"
})(["", ""], TooltipMixin);
Tooltip.propTypes = {
  /**
   * @deprecated Use `renderCloseButton` prop.
   */
  closeButton: PropTypes.node,

  /**
   * The [`Dialog`](#/Dialog%20components?id=dialog) `renderCloseButton` prop.
   */
  renderCloseButton: PropTypes.node,

  /**
   * @ignore
   */
  mediaQuery: CustomPropTypes.mediaQuery,

  /**
   * A contextual popup that displays a description for an element.
   */
  role: PropTypes.string,

  /**
   * The [`Dialog`](#/Dialog%20components?id=dialog) `shouldCloseOnESCKeyPress` prop.
   */
  shouldCloseOnESCKeyPress: PropTypes.bool,

  /**
   * The [`Dialog`](#/Dialog%20components?id=dialog) `shouldCloseOnOutsideClick` prop.
   */
  shouldCloseOnOutsideClick: PropTypes.bool,

  /**
   * The [`Dialog`](#/Dialog%20components?id=dialog) `shouldTakeFocus` prop.
   */
  shouldTakeFocus: PropTypes.bool,

  /**
   * The [`Dialog`](#/Dialog%20components?id=dialog) `shouldTrapFocus` prop.
   */
  shouldTrapFocus: PropTypes.bool,

  /**
   * The [`Dialog`](#/Dialog%20components?id=dialog) `shouldReturnFocus` prop.
   */
  shouldReturnFocus: PropTypes.bool
};
Tooltip.defaultProps = {
  closeButton: null,
  renderCloseButton: null,
  mediaQuery: {},
  modal: false,
  shouldCloseOnESCKeyPress: true,
  shouldCloseOnOutsideClick: false,
  shouldTakeFocus: false,
  shouldTrapFocus: false,
  shouldReturnFocus: false,
  role: 'tooltip'
};
/** @component */

export default Tooltip;
export var StyledTooltip = Tooltip;